// extracted by mini-css-extract-plugin
export default {"header":"BookmarkCard_header__0Dx8n","roleTitle":"BookmarkCard_roleTitle__0BaOW","tags":"BookmarkCard_tags__I-+PZ"};